import { createSlice } from "@reduxjs/toolkit";
import { AddGen, UpdateGen, GetGenList } from "services/other/gen.service";
import { toast } from 'react-toastify';

export const genAddSlice = createSlice({
  name: "genAdd",
  initialState: {
    genAdd: {},
    genAddLoading: false,
    genAddError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(AddGen.pending, (state) => {
      // toast.loading('We are adding the gen 🤯')
      state.genAddLoading = true
    });

    builder.addCase(AddGen.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('New gen added successfully 👌');

      state.genAdd = action.payload
      state.genAddLoading = false
      state.genAddError = null
    });

    builder.addCase(AddGen.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't add the gen 😣")

      state.genAddLoading = false
      state.genAddError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});

export const genUpdateSlice = createSlice({
  name: "genUpdate",
  initialState: {
    genUpdate: {},
    genUpdateLoading: false,
    genUpdateError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(UpdateGen.pending, (state) => {
      // toast.loading('We are updating the gen 🤯')
      state.genUpdateLoading = true
    });

    builder.addCase(UpdateGen.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('Category update successfully 👌');

      state.genUpdate = action.payload
      state.genUpdateLoading = false
      state.genUpdateError = null
    });

    builder.addCase(UpdateGen.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't update the gen 😣")

      state.genUpdateLoading = false
      state.genUpdateError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});



export const genListSlice = createSlice({
  name: "genList",
  initialState: {
    genList: [],
    genListLoading: false,
    genListError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(GetGenList.pending, (state) => {
      state.genListLoading = true
    });

    builder.addCase(GetGenList.fulfilled, (state, action) => {
      toast.dismiss();

      state.genList = action.payload
      state.genListLoading = false
      state.genListError = null
    });

    builder.addCase(GetGenList.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't add the gen 😣")

      state.genListLoading = false
      state.genListError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});